import { Navigate, Outlet } from "react-router";

import { routes } from "~/app/routes/web-routes.ts";
import { Construction } from "~/shared/components/construction/construction.tsx";
import { LoadingSpinner } from "~/shared/components/loading-spinner/loading-spinner.tsx";
import { useDeploymentType } from "~/shared/hooks/use-deployment-type.ts";
import { useFeatureFlagGate } from "~/shared/hooks/use-feature-flag-gate.ts";

export const RoutingGuidePage = () => {
	const { isReady, isEnabled } = useFeatureFlagGate("traxLtlRoutingGuide");
	const { isInternal } = useDeploymentType();

	if (!isReady) {
		return <LoadingSpinner />;
	}

	if (!isInternal) {
		return <Navigate replace to={routes.root} />;
	}

	return isEnabled ? <Outlet /> : <Construction />;
};
